import { render, staticRenderFns } from "./TechStack.vue?vue&type=template&id=4cfb54c8&scoped=true&"
import script from "./TechStack.vue?vue&type=script&lang=js&"
export * from "./TechStack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfb54c8",
  null
  
)

export default component.exports